/**
 * Wellness Tracker Page - FLO SIGNATURE DESIGN SYSTEM v2
 * Displays all wellness tracking charts: Mood, Energy, Mental Clarity, Irritability
 */

import React from 'react';
import { COLORS, SPACING, TYPOGRAPHY } from '../design/tokens';
import { Screen } from '../design/primitives';
import { MoodTracker, EnergyTracker, MentalClarityTracker, IrritabilityTracker } from '../components/ui';

const MoodTrackerPage: React.FC = () => {
  return (
    <Screen>
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        <h1
          style={{
            fontFamily: TYPOGRAPHY.headings.fontFamily,
            fontSize: TYPOGRAPHY.headings.sizes.h1,
            fontWeight: TYPOGRAPHY.headings.weight,
            color: COLORS.text.primary,
            margin: 0,
            marginBottom: SPACING[24],
          }}
        >
          Wellness Tracker
        </h1>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: SPACING[24],
          }}
        >
          <MoodTracker />
          <EnergyTracker />
          <MentalClarityTracker />
          <IrritabilityTracker />
        </div>
      </div>
    </Screen>
  );
};

export default MoodTrackerPage; 